import type { GetUsersParams, RefreshServiceTokenResponse, RefreshServiceTokenRequest } from '@lib/types/users'
import type { PaginatedData } from '@lib/types/paginatedData'
import type { User } from '@openapi'

export function getUsers(payload?: GetUsersParams): Promise<PaginatedData<User>> {
  return this.API.request('get_users', payload)
}

/**
 * Ask for a refreshed Salesforce token. In case the token hasn't expired yet, this method will return the same token as the current one found in the (`getEnv`)[#getenv] result.
 * @returns Promise resolving to an object containing the token
 */
export function refreshServiceToken(payload?: RefreshServiceTokenRequest): Promise<RefreshServiceTokenResponse> {
  return this.API.request('refresh_service_token', payload ?? {})
}

export function refreshAccessToken() {
  return this.API.request('refresh_access_token')
}
